<template>
    <div class="flex flex-col px-6 w-full max-md:px-5 max-md:max-w-full">
      <div
        class="self-start my-4 ml-11 text-lg font-light text-center text-black max-md:my-10 max-md:ml-2.5"
      >
        {{ text }}
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'BreadCrumb',
    props: {
      text: {
        type: String,
        default: '主页/荣誉展示',
      },
    },
  };
  </script>
  
